import { createSelector } from 'reselect'
import { startsWith, cloneDeep, groupBy, map, keys } from 'lodash';
import { maruti, oldsync } from './model'
import { textFilter, numberFilter } from '../../../utilities/listUtils'
import moment from 'moment';

export const getIsFetchingMaruti = (state, props) => state.marutiSync.params.isFetching;
export const getIsMarutiFetched = (state, props) => state.marutiSync.params.marutiFetched;
export const getMarutiList = (state, prop) => state.marutiSync.byId
export const getMarutiCollection = (state, prop) => state.marutiSync.collection
export const getIsSearching = (state, props) => state.marutiSync.params.isSearching;
export const getIsSearchFetched = (state, props) => state.marutiSync.params.searchFetched;
export const getSearchResults = (state, prop) => state.marutiSync.searchResults
export const getOldSyncStatus = (state, prop) => state.marutiSync.fetchedOldSyncStatus
export const filters = (state, prop) => state.marutiSync.filterResults;
export const getNotificationPopup = (state, id) => state.marutiSync.notificationsPopup;

export const getMaruti = (state, props) => {
    if (props.match.path === '/maruti/create') {
        return maruti()
    }
    if (props.match.path === '/maruti/edit/:id') {
        let id = props.match.params.id
        let obj = cloneDeep(state.marutiSync.byId[id]);
        return obj
    }
}

export const getOldSyncData = (state, path) => {
    return oldsync()
}
export const getMarutiParams = (state, props) => {
    const params = {}

    if (startsWith(state.router.location.pathname, '/maruti/create')) {
        params.title = state.marutiSync.params.createTitle
        params.submitButtonText = state.marutiSync.params.createSubmitButtonText
    };

    if (startsWith(state.router.location.pathname, '/maruti/edit/')) {
        params.title = state.marutiSync.params.editTitle
        params.submitButtonText = state.marutiSync.params.editSubmitButtonText
    };

    return params
}

export const getSummary = createSelector(
    getMarutiCollection,
    coll => {
        // let coll = state.marutiSync.collection
        let result = { "status": "", "count": 0 }
        if (coll.length > 0) {
            let group = groupBy(coll, 'status')
            result = map(keys(group), function (e) {
                return { "status": e, "count": group[e].length, "data": group[e] }
            })
        }
        console.log(result)
        return result
    })

export const selectMaruti = createSelector(
    getMarutiList,
    maruti => {
        const keys = Object.keys(maruti)
        const obj = keys.map((key) => { return { key: key, value: key, text: maruti[key].name } })
        return obj
    })


export const selectMarutiSearched = createSelector(
    getSearchResults,
    maruti => {
        const keys = Object.keys(maruti)
        const obj = keys.map((key) => { return { key: key, value: key, text: maruti[key].name } })
        return obj
    })

export const getFilteredMarutiList = createSelector(
    getMarutiList, filters,
    (ledgermap, filters) => {
        let filteredmarutiSync = Object.keys(ledgermap).map(function (key) {
            return ledgermap[key];
        })
        // filteredmarutiSync = textFilter(filteredmarutiSync, filters)
        // filteredmarutiSync = numberFilter(filteredmarutiSync, filters)
        let sortedData = filteredmarutiSync.sort((a, b) => { return moment(b.TRANS_DATE) - moment(a.TRANS_DATE) })
        return sortedData
    })

export const getFilteredMarutiSuccessList = createSelector(
    getMarutiList,
    (ledgermap,) => {
        let filteredmarutiSync = Object.keys(ledgermap).map(function (key) {
            return ledgermap[key];
        })
        let successArray = filteredmarutiSync.filter((item) => item.type === ("success" || "Success"))
        // console.log(successArray, '--------succcces arry')
        let sortedData = successArray.sort((a, b) => { return moment(b.TRANS_DATE) - moment(a.TRANS_DATE) })
        return sortedData
    })

export const getFilteredMarutiInProcessList = createSelector(
    getMarutiList,
    (list) => {
        let filteredmarutiSync = Object.keys(list).map(function (key) {
            return list[key]
        })
        let inProcessArray = filteredmarutiSync.filter((item) => item.type === "in-process")
        let sortedData = inProcessArray.sort((a, b) => { return moment(b.TRANS_DATE) - moment(a.TRANS_DATE) })
        return sortedData
    }
)

export const getFilteredMarutiErrorList = createSelector(
    getMarutiList,
    (ledgermap,) => {
        let filteredmarutiSync = Object.keys(ledgermap).map(function (key) {
            return ledgermap[key];
        })
        let errorArray = filteredmarutiSync.filter((item) => item.type === ("error" || "Error"))
        let sortedData = errorArray.sort((a, b) => { return moment(b.TRANS_DATE) - moment(a.TRANS_DATE) })
        return sortedData
    })

export const getFilteredMarutiExceptionList = createSelector(
    getMarutiList,
    (ledgermap,) => {
        let filteredmarutiSync = Object.keys(ledgermap).map(function (key) {
            return ledgermap[key];
        })
        let exceptionArray = filteredmarutiSync.filter((item) => item.type === ("exception" || "Exception"))
        let sortedData = exceptionArray.sort((a, b) => { return moment(b.TRANS_DATE) - moment(a.TRANS_DATE) })
        return sortedData
    })
